import { render, staticRenderFns } from "./BaseOrganizationCard.vue?vue&type=template&id=13323aa8"
import script from "./BaseOrganizationCard.vue?vue&type=script&lang=js"
export * from "./BaseOrganizationCard.vue?vue&type=script&lang=js"
import style0 from "./BaseOrganizationCard.vue?vue&type=style&index=0&id=13323aa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports